




























import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator';
import {Tag} from '@/modules/blog/types';
import {State} from 'vuex-class';
import {notify} from '@/modules/core/notification';

/**
 * @author Alejandro G. Riaño <agutierrez@so>
 */
@Component
export default class TagDetail extends Vue {
    public $refs: Vue['$refs'] & {
        form: {
            validate (): boolean,
        },
    }
    /**
     * Controla la visibilidad del dialogo
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Etiqueta actualmente en edición
     */
    @State(state => state.blog.tag)
    public tag: Tag

    public valid = true
    public saving = false

    /**
     * Reglas de validación para el formulario
     */
    public get rules () {
        return {
            name: [
                (value: string) => value.length < 40 || 'El nombre de la etiqueta no puede tener mas de 40 caracteres',
            ],
        }
    }

    public async save () {
        if (!this.$refs.form.validate()) {
            return
        }

        this.saving = true
        await this.$store.dispatch('blog/saveTag')

        this.saving = false
        this.$emit('input', false)
        notify(`La etiqueta ${this.tag.name} se ha guardado correctamente`)
    }
}
